export type BrandId = 'voltron' | 'vatton';

export function isVoltronHost(): boolean {
  if (typeof window === 'undefined') return false;
  return window.location.hostname.includes('voltron');
}

export function getBrand(): BrandId {
  return isVoltronHost() ? 'voltron' : 'vatton';
}

export function getBrandName(): string {
  return getBrand() === 'voltron' ? 'Voltron' : 'Vatton';
}

export function getDefaultLanguage(): 'en' | 'ko' | 'id' {
  return isVoltronHost() ? 'en' : 'ko';
}

export function getDefaultDarkMode(): boolean {
  return isVoltronHost();
}

export function getWalletTitle(): string {
  return getBrand() === 'voltron'
    ? 'Voltron Wallet — Voltron Blockchain'
    : 'Vatton Wallet — Vatton Blockchain';
}
